import { isBefore } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { DatePickerDateType } from 'ui';
import { useGetStartTimeSlots } from '../../../../hooks';

export const useGetStartTimeOptions = () => {
  const { t } = useTranslation();
  const getStartTimeSlots = useGetStartTimeSlots();

  return useCallback(
    ({ startDate }: { startDate: DatePickerDateType }) =>
      getStartTimeSlots(startDate).map((date) => ({
        disabled: isBefore(date, new Date()),
        label: t('dateFormats.time', { date }),
        value: t('dateFormats.time', { date }),
      })),
    [getStartTimeSlots, t],
  );
};
